<template>
    <section class="section-outline property-nearby-home-values" v-if="listings">
        <mvtCollapse :disable="disableCollapse" :isActive="true">
            <template v-slot:header>
                <h2 class="f2 text-bold">Nearby home values</h2>
                <div class="f5 text-gray">{{ listings.length }} closest off-market {{ nearbyPropertyLabel }}.</div>
            </template>
            <template v-slot:default>
                <div class="nearby-home-values-table">
                    <table>
                        <thead>
                            <tr>
                                <th class="col-address"></th>
                                <th class="col-value f7 text-gray text-bold">Est. value</th>
                                <th class="col-bedbath f7 text-gray text-bold">Bed/bath</th>
                                <th class="col-sqft f7 text-gray text-bold">Sqft</th>
                                <th class="col-dist f7 text-gray text-bold">mi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in listings" :key="item.id">
                                <td class="col-address">
                                    <a :href="glb.appUrl + item.dppUrl" class="link f6 text-bold">{{ item.fullAddress }}</a>
                                </td>
                                <td class="col-value f6 text-bold">{{ formatValue(item.estimatedValue) }}</td>
                                <td class="col-bedbath f6">{{ formatBedBath(item.beds, item.baths) }}</td>
                                <td class="col-sqft f6">{{ formatSqft(item.sqft) }}</td>
                                <td class="col-dist f6">{{ formatDistance(item.distance) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p class="f8 text-gray nearby-home-values-disclaimer">
                    Estimated values are based on public record data and automated valuation models. Values are not guaranteed and may not reflect current market conditions.
                </p>
            </template>
        </mvtCollapse>
    </section>
</template>
<script src="./property-nearbyhomevalues.js"></script>

<style lang="scss">
@use "./property-nearbyhomevalues.scss" as *;
</style>
